import React from 'react';

import { SignUpSuccess } from 'components/SignUpForm/success';

export const PasswordEmailSuccessPage: React.FC = () => {
  return <SignUpSuccess resetPassword={true} />;
};
